import tools from 'altrac-conversions';

function machineState(runSignal, offRpm, highRpm) {
  if (offRpm && highRpm) {
    const runSignalTextState = tools.runSignalToState(runSignal, offRpm, highRpm);
    return !!(runSignalTextState.toUpperCase() === 'LOW' || runSignalTextState.toUpperCase() === 'HIGH');
  }
  return runSignal > 0;
}

export function controllerNotIntegrated(statusO, machineOnOff, machineRunning, deviceName, important) {
  if (machineOnOff && machineRunning) {
    statusO.other.push({
      id: 'pumpRunningState',
      rank: important ? 10 : 100,
      code: 'success',
      category: 'engine',
      shortMessage: 'Machine Running',
      message: `Pump ${deviceName} is running`,
    });
  } else if (!machineOnOff && machineRunning) {
    statusO.other.push({
      id: 'pumpShouldBeOffState',
      rank: important ? 30 : 100,
      code: 'warning',
      category: 'engine',
      shortMessage: 'Machine Running',
      message: `Pump ${deviceName} should be off, but is running`,
    });
  } else if (machineOnOff && !machineRunning) {
    statusO.other.push({
      id: 'pumpShouldBeOnState',
      rank: important ? 10 : 100,
      code: 'danger',
      category: 'engine',
      shortMessage: 'Not Running',
      message: `Pump ${deviceName} should be running`,
    });
  } else {
    statusO.other.push({
      id: 'pumpStoppedState',
      rank: important ? 100 : 100,
      code: 'normal',
      category: 'engine',
      shortMessage: 'Engine Off',
      message: `Engine at pump ${deviceName} is off`,
    });
  }
}

function calculateTimeSinceStart(reading) {
  const nowSeconds = Date.now() / 1000;
  const startTime = tools.isNumber(reading.R1T) ? reading.R1T : reading[132];
  const timeDiff = nowSeconds - startTime;
  return timeDiff > 0 ? timeDiff : 0;
}

export function controllerInverter(statusO, reading0, machineOnOff, machineRunning, deviceName, _physical) {
  const engineState = tools.isNumber(reading0.R1S) ? reading0.R1S : reading0[140];
  const timeSinceStartSeconds = calculateTimeSinceStart(reading0);
  const controllerAutoMode = tools.isNumber(reading0.XA) ? reading0.XA : reading0[202];
  const controllerAutoSwitch = tools.isNumber(reading0.DI1) ? reading0.DI1 : (reading0['143'] > 9000 ? 1 : 0);
  const controllerRunMode = tools.isNumber(reading0.XR) ? reading0.XR : reading0[203];

  if (controllerAutoMode === 1) {
    statusO.other.push({
      id: 'pumpControllerAutoOn',
      rank: 100,
      code: 'normal',
      category: 'controller',
      shortMessage: 'A/S Auto On',
      message: `Pump ${deviceName} controller is in auto mode`,
    });
    statusO.stateIndicator = true;
  } else {
    statusO.other.push({
      id: 'pumpControllerAutoOff',
      rank: 50,
      code: 'normal',
      category: 'controller',
      shortMessage: 'A/S Auto Off',
      message: `Pump ${deviceName} controller is not in auto mode`,
    });
    statusO.stateIndicator = false;
  }

  if (!controllerAutoMode && controllerRunMode) {
    if (controllerAutoSwitch) {
      statusO.other.push({
        id: 'pumpControllerManualRun',
        rank: 100,
        code: 'normal',
        category: 'controller',
        shortMessage: 'A/S Auto On',
        message: `Pump ${deviceName} controller is in manual and switch position relay has power`,
      });
    } else {
      statusO.other.push({
        id: 'pumpControllerManualRunSwitchOff',
        rank: 20,
        code: 'disconnected',
        category: 'controller',
        shortMessage: 'A/S switch off',
        message: `Pump ${deviceName} controller is in manual should be running, but switch is in wrong position`,
      });
      statusO.stateIndicator = false;
      statusO.deviceHeadlineDanger.enabled = true;
      statusO.deviceHeadlineDanger.text.push('Switch on equipment is not in auto position');
    }
  } else if (!controllerAutoSwitch) {
    statusO.other.push({
      id: 'pumpControllerManualRunSwitchOff',
      rank: 50,
      code: 'normal',
      category: 'controller',
      shortMessage: 'A/S switch off',
      message: `Pump ${deviceName} controller is in manual switch is off`,
    });
    statusO.stateIndicator = false;
    statusO.deviceHeadlineWarning.enabled = true;
    statusO.deviceHeadlineWarning.text.push('Switch on equipment is not in auto position');
  }

  let controllerId = 'pump';
  let controllerRank = 10;
  let controllerCode = 'normal';
  let controllerShortMessage = 'Unknown issue';
  let controllerMessage = 'Unknown issue';

  switch (engineState) {
    case 0:
    case 1:
    case 2:
      controllerId = 'pumpControllerEngineStopped';
      controllerRank = 100;
      controllerCode = 'normal';
      controllerShortMessage = 'Engine Stopped';
      controllerMessage = `Pump ${deviceName} is stopped`;
      break;
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
      controllerId = 'pumpControllerCrankOn';
      controllerRank = 10;
      controllerCode = 'info';
      controllerShortMessage = 'Crank on';
      controllerMessage = `Pump ${deviceName} crank on`;
      break;
    case 8:
      controllerId = 'pumpControllerFalseStart';
      controllerRank = 10;
      controllerCode = 'danger';
      controllerShortMessage = 'False Start';
      controllerMessage = `Pump ${deviceName} false start`;
      break;
    case 9:
      controllerId = 'pumpControllerWarmup';
      controllerRank = 10;
      controllerCode = 'info';
      controllerShortMessage = 'Warmup';
      controllerMessage = `Pump ${deviceName} warmup`;
      break;
    case 10:
    case 11:
    case 12:
      controllerId = 'pumpControllerRunning';
      controllerRank = 10;
      controllerCode = 'success';
      controllerShortMessage = 'Running';
      controllerMessage = `Pump ${deviceName} running loaded`;
      break;
    case 13:
    case 14:
    case 15:
    case 16:
      controllerId = 'pumpControllerCooldown';
      controllerRank = 10;
      controllerCode = 'info';
      controllerShortMessage = 'Cooldown';
      controllerMessage = `Pump ${deviceName} cooldown`;
      break;
    default:
      controllerId = 'pumpControllerUnknownEngineState';
      controllerRank = 30;
      controllerCode = 'danger';
      controllerShortMessage = 'Unknown engine state';
      controllerMessage = `Pump ${deviceName} unexpected engine state`;
      break;
  }

  statusO.other.push({
    id: controllerId,
    rank: controllerRank,
    code: controllerCode,
    category: 'controller',
    shortMessage: controllerShortMessage,
    message: controllerMessage,
  });

  if (engineState >= 8 && engineState <= 13 && !machineRunning) {
    statusO.deviceHeadlineDanger.enabled = true;
    statusO.deviceHeadlineDanger.text.unshift('Machine should be ON');
    statusO.other.push({
      id: 'pumpShouldBeOnState',
      rank: 1,
      code: 'danger',
      category: 'engine',
      shortMessage: 'Controller Issue',
      message: `Run signal is off, pump ${deviceName} should be running `,
    });

    if (timeSinceStartSeconds > 300) {
      statusO.other.push({
        id: 'pumpShouldBeOnStatePastDue',
        rank: 2,
        code: 'danger',
        category: 'engine',
        shortMessage: 'Controller Issue',
        message: `Run signal is off, pump ${deviceName} should have started ${Math.round(timeSinceStartSeconds / 60)} min ago`,
      });
    }
  }
}

export function pressureState(statusO, reading0, machineOnOff, machineRunning, deviceName, physical) {
  const controllerAutoMode = tools.isNumber(reading0.XA) ? reading0.XA : reading0[202];
  const pressure = tools.fourToTwenty(
    tools.isNumber(reading0.AN1) ? reading0.AN1 : reading0['133'],
    physical.min || 0,
    physical.max || 100,
    physical.zero || 0,
    physical.precision || 0,
  );

  if (pressure === 'ERH' || pressure === 'OFF') {
    if (!controllerAutoMode && (machineRunning || machineOnOff)) {
      const lastCode = statusO.other.at(-1)?.code;
      statusO.other.push({
        id: 'pumpControllerAutoPressureBadReading',
        rank: 5,
        code: lastCode ?? 'normal',
        category: 'sensors',
        shortMessage: 'Pump running pressure sensor bad',
        message: `Pump ${deviceName} is running but pressure sensor is bad`,
      });
    }

    statusO.other.push({
      id: 'pressureBadReading',
      rank: 20,
      code: 'deviceProblem',
      category: 'sensors',
      shortMessage: 'Pressure sensor reading bad',
      message: `Pump ${deviceName} pressure sensor reading is bad`,
    });
    statusO.deviceHeadlineDanger.enabled = true;
    statusO.deviceHeadlineDanger.text.push('Pressure sensor fault');
  }
}

export function powerState(statusO, reading0, physical) {
  const inputPower = (tools.isNumber(reading0.PM8) ? reading0.PM8 : reading0['186']) & 0x4;

  if (inputPower) {
    statusO.other.push({
      id: 'pumpControllerPowerOn',
      rank: 100,
      code: 'normal',
      category: 'electricity',
      shortMessage: 'Controller has power',
      message: `Controller has power at ${physical.deviceNumber} `,
    });
  } else {
    statusO.other.push({
      id: 'pumpControllerPowerOff',
      rank: 15,
      code: 'disconnected',
      category: 'controller',
      shortMessage: 'Controller does not have power',
      message: `Controller does not have power at ${physical.deviceNumber} `,
    });
    statusO.deviceHeadlineDanger.enabled = true;
    statusO.deviceHeadlineDanger.text.push('Altrac is not receiving power');
    return false;
  }
  return true;
}

export function status(statusO, device) {
  const deviceName = device.physical.deviceNumber;
  const reading0 = device.reading0 || {};
  const machineOnOff = ((tools.isNumber(reading0.R1) ? reading0.R1 : reading0['131']) & 1) >>> 0;
  const machineRunning = machineState(tools.isNumber(reading0.R1F) ? reading0.R1F : reading0['134']);

  powerState(statusO, reading0, device.physical);

  let controller = 'notIntegrated';
  if (device.interface_versioned?.data?.other?.controller) {
    controller = device.interface_versioned.data.other.controller;
  } else if (device.physical?.controller) {
    controller = device.physical.controller;
  }

  let noController = false;

  switch (controller) {
    case 'inverter':
      controllerInverter(statusO, reading0, machineOnOff, machineRunning, deviceName, device.physical);
      break;
    case 'flow':
      break;
    default:
      noController = true;
  }

  controllerNotIntegrated(statusO, machineOnOff, machineRunning, deviceName, noController);

  const inThree = device.interface_versioned?.data?.other?.inThree;
  if (inThree === 'pressure') {
    pressureState(statusO, reading0, machineOnOff, machineRunning, deviceName, device.physical);
  }
}
